<template>
  <partner-refer-alert v-if="visible" />
</template>

<script>
import PartnerReferAlert from '@/views/config/partner-refer/component/alert-message';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { getMessageStringByRules, popUpDialogForAfterValidate } from '@/views/config/partner-refer/helper/validator';
import { getPartnerRefer } from '@/views/config/partner-refer/helper/utils';
import { isEmptyVal } from '@/utils';
import InitModalConfigDialog from '@/views/config/partner-refer/plans/init-modal-config.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { OPC_CONSTANT_PATH } from '@/common/constants';
import eventListenerMixin from '@/views/config/partner-refer/mixin/event-listener';
import { promotionInstanceInfo } from '@/common/mixin/promotion-mixin';
import { PROMOTION_TYPE } from '@/views/config/coupon/helper/constant';
import { logger } from '@/utils/log';

// when the partner init at first, should sign the status
let globalInitFeatureRegister = false;

export default {
  components: { PartnerReferAlert },
  mixins: [eventListenerMixin],
  created() {
    this.initModalConfigDialog = new ServiceConfirm(InitModalConfigDialog);
    promotionInstanceInfo.setPromotionInstance(PROMOTION_TYPE.pureReferralCoupon, this);
  },
  beforeDestroy() {
    // Clean up promotion instance to prevent memory leaks
    promotionInstanceInfo.removePromotionInstance(PROMOTION_TYPE.pureReferralCoupon);
  },
  computed: {
    ...mapGetters(['referralCouponStatus', 'lastShowInEligibleMsg', 'promoExternalProduct', 'getSelectedPlansWithQuantityMap', 'soldToContact', 'partnerMessageLoading', 'showInEligibleMsg', 'ignoreCheckPartner', 'partnerRefer', 'partnerFeaturesDependOnRules', 'promotionInfo', 'computedAmountLoading']),
    visible() {
      // [partner hard code]
      // Whether the banner mode needs to be displayed
      // [partner A/B/C] test use planCard mode, will show ineligible banner message in checkout page
      if (this.partnerFeaturesDependOnRules?.usePlanCardMode) {
        return this.showInEligibleMsg || (this.lastShowInEligibleMsg && this.partnerMessageLoading);
      }

      return !this.promoExternalProduct;
    },
    initOfferFeatureDetailContent() {
      return getMessageStringByRules(this.partnerRefer.initOfferFeatureDetailContent);
    },
  },
  data() {
    return {
      blockModalOfferDetailVisible: false,
    };
  },
  methods: {
    autoVerifyAction() {
      const promotionList = _.values(this.promotionInfo);
      logger.info('promotion-watch-fingerprint --- pureReferralCoupon', promotionList);
      const validateList = _.map(promotionList, (info) => (info.validate ?? _.noop)());
      Promise.all(validateList);
    },
    promotionAfterValidate() {
      const afterValidateList = _.values(this.promotionInfo)
        .map((info) => (info.afterValidate ?? _.noop)());
      Promise.all(afterValidateList);
    },
    popUpIneligibleDialog(invalid) {
      const partnerRefer = getPartnerRefer();

      if (isEmptyVal(partnerRefer)) return;
      if (this.ignoreCheckPartner) return;

      /**
       * blockModalOfferDetailVisible in order to avoid show repeat dialog
       */
      if (
        partnerRefer.rules?.afterBlockOfferModalSwitch
        && !this.partnerMessageLoading
        && invalid
        && !this.blockModalOfferDetailVisible
        && !this.lastShowInEligibleMsg
        // record last whether to show msg (in order to fix call backend api), avoid repeat show dialog (when the last check is invalid, current is also invalid, we do not show dialog)
        // when the api pending, origin check result is false, pending -> will lead check status (false -> true), will call watch showInEligibleMsg function
        // when the api is resolved, check result will switch (true -> false), will call watch showInEligibleMsg function
      ) {
        this.blockModalOfferDetailVisible = true;

        popUpDialogForAfterValidate()
          .then(() => {
            if (this.partnerRefer?.features?.afterBlockOfferModalConfirmAction === "redirect") {
              window.location.href = OPC_CONSTANT_PATH.basic2pro;
            }
          })
          .finally(() => {
            this.blockModalOfferDetailVisible = false;
          });
      }
    },
    showInitModalConfigDialog() {
      if (globalInitFeatureRegister) return;

      if (!isEmptyVal(this.initOfferFeatureDetailContent) ) {
        globalInitFeatureRegister = true;
        return this.initModalConfigDialog.confirm();
      }
    },
  },
  watch: {
    showInEligibleMsg: {
      handler(val) {
        this.popUpIneligibleDialog(val);
      },
    },
    computedAmountLoading: {
      handler(value) {
        !value && this.promotionAfterValidate();
      },
    },
  },
  mounted() {
    this.showInitModalConfigDialog();
  },
};
</script>
